module.exports = __webpack_public_path__ + "img/wide.46a079da.jpg";